import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import {
  ICampaignSimpleMessage,
  ICampaignSimpleMessageInput,
} from "@/interfaces/campaign-simple-message.interface";
import { FilterType, IFilter } from "@/types/filter.types";

class CampaignSimpleMessageService {
  private baseUrl = "api/v1/campaignsimplemessage";

  async getAll(): Promise<ICampaignSimpleMessage[]> {
    const response = await httpRequest.get(this.baseUrl);
    return response;
  }

  async getById(id: number): Promise<ICampaignSimpleMessage> {
    const response = await httpRequest.get(`${this.baseUrl}/${id}`);
    return response;
  }

  async getByCampaignId(campaignId: number): Promise<ICampaignSimpleMessage | null> {
    try {
      const paginationQuery = buildPaginationQuery({ pageNumber: 1, pageSize: 1 });
      const filter: IFilter<ICampaignSimpleMessage>[] = [
        {
          property: "campaignId",
          filterType: FilterType.Equals,
          value: campaignId,
        },
      ];

      const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
        filter,
      });

      return response?.items?.[0] ?? null;
    } catch {
      return null;
    }
  }

  async create(data: ICampaignSimpleMessageInput): Promise<ICampaignSimpleMessage> {
    const payload = {
      campaignId: data.campaignId,
      messageText: data.messageText,
      hasActionButton: data.hasActionButton,
      buttonText: data.hasActionButton ? data.buttonText : undefined,
      buttonLink: data.hasActionButton ? data.buttonLink : undefined,
    };
    const response = await httpRequest.post(this.baseUrl, payload);
    return response;
  }

  async update(id: number, data: ICampaignSimpleMessageInput): Promise<ICampaignSimpleMessage> {
    const payload = {
      campaignId: data.campaignId,
      messageText: data.messageText,
      hasActionButton: data.hasActionButton,
      buttonText: data.hasActionButton ? data.buttonText : undefined,
      buttonLink: data.hasActionButton ? data.buttonLink : undefined,
    };
    const response = await httpRequest.put(`${this.baseUrl}/${id}`, payload);
    return response;
  }

  async delete(id: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${id}`);
  }
}

const campaignSimpleMessageService = new CampaignSimpleMessageService();
export default campaignSimpleMessageService;
